<template>
  <div class="kingdom" @click="hideVideo">
    <section class="main">
      <div class="t_pic_box">
        <img class="t_pic" src="../assets/img/meishi.jpg" alt />
      </div>

      <!-- 明星单品 -->
      <div class="develop" id="king1">
        <div class="d_tit">
          <div class="top_title">
            <div class="title1">
              BEST
              <br />SELLER
            </div>
            <div class="title2">明星单品</div>
          </div>
        </div>
        <div class="goods">
          <!-- 左右切换箭头 -->
          <div class="swiper-button swiper-button-prev2" @click="switchSlide('carousel0', 'prev')">
            <img src="../assets/img/arrow_left.png" alt />
          </div>
          <div class="swiper-button swiper-button-next2" @click="switchSlide('carousel0', 'next')">
            <img src="../assets/img/arrow_right.png" alt />
          </div>

          <el-carousel
            :interval="0"
            indicator-position="none"
            arrow="never"
            ref="carousel0"
          >
            <el-carousel-item v-for="(page, pageIndex) in bestSellerPages" :key="pageIndex">
              <div class="swiper-slide">
                <div class="pic-item" v-for="(item, index) in page" :key="index">
                  <img :src="item.img" @click.stop="handleItemClick(item)" alt />
                  <div class="pic-name">{{ item.name }}</div>
                  <div class="pic-desc">{{ item.desc }}</div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <!-- 坚果类 -->
      <div class="develop" id="king2">
        <div class="d_tit">
          <div class="top_title">
            <div class="title1">
              NUT
              <br />PRODUCTS
            </div>
            <div class="title2">坚果类</div>
          </div>
        </div>
        <div class="goods">
          <!-- 左右切换箭头 -->
          <div class="swiper-button swiper-button-prev2" @click="switchSlide('carousel1', 'prev')">
            <img src="../assets/img/arrow_left.png" alt />
          </div>
          <div class="swiper-button swiper-button-next2" @click="switchSlide('carousel1', 'next')">
            <img src="../assets/img/arrow_right.png" alt />
          </div>

          <el-carousel
            :interval="0"
            indicator-position="none"
            arrow="never"
            ref="carousel1"
          >
            <el-carousel-item v-for="(page, pageIndex) in nutProductPages" :key="pageIndex">
              <div class="swiper-slide">
                <div class="pic-item" v-for="(item, index) in page" :key="index">
                  <img :src="item.img" @click.stop="handleItemClick(item)" alt />
                  <div class="pic-name">{{ item.name }}</div>
                  <div class="pic-desc">{{ item.desc }}</div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <!-- 凉果蜜饯 -->
      <div class="develop" id="king3">
        <div class="d_tit">
          <div class="top_title">
            <div class="title1">
              PRESERVED
              <br />FRUITS
            </div>
            <div class="title2">凉果蜜饯</div>
          </div>
        </div>
        <div class="goods">
          <!-- 左右切换箭头 -->
          <div class="swiper-button swiper-button-prev2" @click="switchSlide('carousel2', 'prev')">
            <img src="../assets/img/arrow_left.png" alt />
          </div>
          <div class="swiper-button swiper-button-next2" @click="switchSlide('carousel2', 'next')">
            <img src="../assets/img/arrow_right.png" alt />
          </div>

          <el-carousel
            :interval="0"
            indicator-position="none"
            arrow="never"
            ref="carousel2"
          >
            <el-carousel-item v-for="(page, pageIndex) in preservedFruitPages" :key="pageIndex">
              <div class="swiper-slide">
                <div class="pic-item" v-for="(item, index) in page" :key="index">
                  <img :src="item.img" @click.stop="handleItemClick(item)" alt />
                  <div class="pic-name">{{ item.name }}</div>
                  <div class="pic-desc">{{ item.desc }}</div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <!-- 视频播放弹窗：activeVideo 控制当前展示的视频 -->
      <div
        class="videobg"
        v-for="n in 6"
        :key="'video' + n"
        v-show="activeVideo === String(n)"
      >
        <video controls="controls" :id="'video' + n">
          <source :src="videoSources[n - 1]" type="video/mp4" />Your browser does not support the video tag.
        </video>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  watch: {
    $route() {
      this.scrolls(this.$route.query.id);
    }
  },
  data() {
    return {
      // 当前播放的视频编号（'1'~'6'），null 表示无视频播放
      activeVideo: null,

      // 视频资源列表（冻结常量，避免运行时修改）
      videoSources: Object.freeze([
        require('../assets/video/yao.mp4'),
        require('../assets/video/gen.mp4'),
        require('../assets/video/chestnut_montage.mp4'),
        require('../assets/video/hawthorn_origin_tvc.mp4'),
        require('../assets/video/sweet_potato_origin.mp4'),
        require('../assets/video/cool_chestnut_montage.mp4')
      ]),

      // 明星单品（videoType 点击播放视频，link 点击跳转外链）
      bestSellers: Object.freeze([
        { img: require('../assets/img/1.png'), videoType: '3', name: '现炒板栗', desc: '精选燕山山脉板栗 香甜软糯' },
        { img: require('../assets/img/p9.png'), videoType: '4', name: '霜糖山楂', desc: '白里透红 酸甜可口' },
        { img: require('../assets/img/p11.png'), videoType: '5', name: '现烤红薯', desc: '精选高甜度红薯 甜蜜软糯' },
        { img: require('../assets/img/p10.png'), videoType: '6', name: '冰魔栗', desc: '燕山山脉板栗 口感细腻绵柔' },
        { img: require('../assets/img/goods/sweet_potato.png'), link: 'https://detail.tmall.com/item.htm?id=707885770978', name: '红瑶薯仔', desc: '纯薯甜 不加糖' }
      ]),

      // 坚果类
      nutProducts: Object.freeze([
        { img: require('../assets/img/huashen.png'), link: 'https://detail.tmall.com/item.htm?id=647553510659', name: '原味花生', desc: '精选花生 高温烘炒 原味香脆' },
        { img: require('../assets/img/songzi.png'), link: 'https://detail.tmall.com/item.htm?id=527179944501', name: '红松子', desc: '肉质香酥 油而不腻' },
        { img: require('../assets/img/3.png'), link: 'https://detail.tmall.com/item.htm?id=1002134761442', name: '奶油味夏威夷果', desc: '果仁香酥 奶香可口' },
        { img: require('../assets/img/4.png'), link: 'https://detail.tmall.com/item.htm?id=753902828220', name: '原色开心果', desc: '颗粒饱满 口味清香' },
        { img: require('../assets/img/yaoguo.png'), link: 'https://detail.tmall.com/item.htm?id=743899282233', name: '腰果', desc: '松脆可口 香而不腻' },
        { img: require('../assets/img/2.png'), link: 'https://detail.tmall.com/item.htm?id=999989334148', name: '奶香碧根果', desc: '皮薄肉厚 奶香浓郁' }
      ]),

      // 凉果蜜饯
      preservedFruits: Object.freeze([
        { img: require('../assets/img/6.png'), link: 'https://detail.tmall.com/item.htm?id=998517706744', name: '芒果干', desc: '酸甜清香 甜而不腻' },
        { img: require('../assets/img/huang.png'), link: 'https://detail.tmall.com/item.htm?id=544674715824', name: '黄桃干', desc: '甜而不腻 口味独特' },
        { img: require('../assets/img/goods/guava.png'), link: 'https://detail.tmall.com/item.htm?id=684753734882', name: '芭乐干', desc: '软糯清甜 果香浓郁' },
        { img: require('../assets/img/8.png'), link: 'https://detail.tmall.com/item.htm?id=785413416369', name: '雪花半梅', desc: '气味芬芳 酸甜清爽' }
      ])
    };
  },
  computed: {
    // 明星单品分页（每页4个）
    bestSellerPages() {
      return this.chunk(this.bestSellers, 4);
    },
    // 坚果类分页
    nutProductPages() {
      return this.chunk(this.nutProducts, 4);
    },
    // 凉果蜜饯分页
    preservedFruitPages() {
      return this.chunk(this.preservedFruits, 4);
    }
  },
  methods: {
    // 将数组按指定大小分页，用于轮播图每页展示固定数量商品
    chunk(arr, size) {
      const result = [];
      for (let i = 0; i < arr.length; i += size) {
        result.push(arr.slice(i, i + size));
      }
      return result;
    },
    // 统一轮播图切换方法：根据 ref 名称和方向操作对应轮播
    switchSlide(refName, direction) {
      const carousel = this.$refs[refName];
      if (!carousel) return;
      direction === 'prev' ? carousel.prev() : carousel.next();
    },
    // 商品点击统一处理：有视频则播放视频，有链接则跳转外链
    handleItemClick(item) {
      if (item.videoType) {
        this.goVideo(item.videoType);
      } else if (item.link) {
        this.goto(item.link);
      }
    },
    // 播放指定编号的视频
    goVideo(type) {
      this.activeVideo = type;
      const video = document.getElementById(`video${type}`);
      if (video) video.play();
    },
    // 跳转到外部链接
    goto(url) {
      window.open(url, '_blank');
    },
    // 隐藏并暂停当前播放的视频
    hideVideo() {
      if (this.activeVideo) {
        const video = document.getElementById(`video${this.activeVideo}`);
        if (video) video.pause();
      }
      this.activeVideo = null;
    },
    // 平滑滚动到指定区块
    scrolls(id) {
      const target = document.getElementById(`king${id}`);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    }
  },
  mounted() {
    this.scrolls(this.$route.query.id);
  }
};
</script>

<style lang="scss" scoped>
.kingdom {
  .t_pic_box {
    font-size: 0;
  }
  .t_pic {
    width: 100%;
  }
  .develop {
    width: 1200px;
    margin: 80px auto;
    .top_title {
      position: relative;
      text-align: center;
      margin-bottom: 53px;
    }

    .top_title .title1 {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      font-family: 'HarmonyOS Sans SC';
      font-size: 60px;
      color: rgba(76, 1, 4, 0.05);
      line-height: 60px;
      text-align: center;
      font-weight: 400;
      margin-bottom: 6px;
    }

    .top_title .title2 {
      font-family: 'HarmonyOS Sans SC';
      font-size: 40px;
      color: #4c0104;
      text-align: center;
      font-weight: 500;
      width: 100%;
      margin-bottom: 85px;
      padding-top: 32px;
      position: relative;
      z-index: 1;
    }
    .goods .pic-item {
      margin-right: 15px;
    }

    .goods .swiper-slide {
      justify-content: normal;
    }
    .goods .pic-name {
      height: 50px;
      line-height: 50px;
      opacity: 1;
    }
    .goods .pic-desc {
      padding: 0 20px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #666666;
      letter-spacing: 0;
      line-height: 30px;
      text-align: center;
    }
  }
}
</style>
<style lang="scss">
.kingdom .goods .el-carousel__container {
  height: 398px;
}
</style>
